import React from 'react';
import { Card } from 'react-bootstrap';

function About() {
  return (
    <>
      <Card.Title>Conductor Control</Card.Title>
      <Card.Text>A work in progress.</Card.Text>
    </>
  );
}

export default About;
